import { render, staticRenderFns } from "./FabricListCard.vue?vue&type=template&id=7e5f1c20&scoped=true"
import script from "./FabricListCard.vue?vue&type=script&lang=js"
export * from "./FabricListCard.vue?vue&type=script&lang=js"
import style0 from "./FabricListCard.vue?vue&type=style&index=0&id=7e5f1c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5f1c20",
  null
  
)

export default component.exports